export default "__VITE_ASSET__CBKZ3cBb__"